import React from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../CartContext";
import { FiTrash2 } from "react-icons/fi";
import Header from "../components/Header";
import Footer from "../components/Footer";

const CartPage = () => {
    const navigate = useNavigate();
    const { cart, removeFromCart, updateQuantity } = useCart();
    const totalPrice = cart.reduce((total, item) => total + item.variant.price * item.quantity, 0);

    const handleProceedToCheckout = () => {
        if (cart.length === 0) {
            alert("Your cart is empty! Add some products.");
            navigate("/cart");
            return;
        }
        localStorage.setItem("checkoutAllowed", "true");  // ✅ Allow checkout access
        navigate("/checkout");
    };


    return (
        <div className="min-h-screen flex flex-col bg-black text-rose-300">
            {/* Header */}
            <Header />

            {/* Main Content */}
            <div className="flex-grow pt-28 pb-12 px-4">
                {/* Page Title */}
                <h2
                    className="text-4xl md:text-6xl font-bold text-center mb-8"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                    Your <span className="text-white">Cart</span>
                </h2>

                {/* Empty Cart View */}
                {cart.length === 0 ? (
                    <div className="flex flex-col items-center justify-center space-y-6">
                        <p className="text-lg text-center">Your cart is empty.</p>
                        <button
                            onClick={() => navigate("/products")}
                            className="px-6 py-3 bg-rose-300 text-black font-semibold rounded-lg hover:bg-rose-400 transition"
                        >
                            Continue Shopping
                        </button>
                    </div>
                ) : (
                    <div className="max-w-5xl mx-auto space-y-6">
                        {/* Cart Items */}
                        {cart.map((item) => (
                            <div
                                key={`${item.id}-${item.variant.color}-${item.variant.model}`}
                                className="flex flex-col md:flex-row items-center md:items-stretch glass border border-rose-300 p-4 rounded-lg shadow-lg hover:scale-105 transition"
                            >
                                {/* Image Section */}
                                <img
                                    src={item.variant.image_url}
                                    alt={item.variant.model || item.variant.color}
                                    className="w-full md:w-40 h-40 object-cover rounded-lg"
                                />

                                {/* Item Details */}
                                <div className="flex-1 px-4 text-center md:text-left">
                                    <h3 className="text-lg md:text-xl font-semibold mb-2">{item.variant.model || item.variant.color}</h3>
                                    <p className="text-rose-400 text-sm md:text-base mb-4">${item.variant.price.toFixed(2)}</p>

                                    {/* Quantity Controls */}
                                    <div className="flex justify-center md:justify-start items-center space-x-4">
                                        <button
                                            onClick={() => updateQuantity(item.id, item.variant, item.quantity - 1)}
                                            className={`w-8 h-8 flex items-center justify-center bg-rose-300 text-black font-bold text-lg rounded-full hover:bg-rose-400 transition ${item.quantity === 1 ? "opacity-50 cursor-not-allowed" : ""
                                                }`}
                                            disabled={item.quantity === 1}
                                        >
                                            -
                                        </button>
                                        <span className="text-lg">{item.quantity}</span>
                                        <button
                                            onClick={() => updateQuantity(item.id, item.variant, item.quantity + 1)}
                                            className="w-8 h-8 flex items-center justify-center bg-rose-300 text-black font-bold text-lg rounded-full hover:bg-rose-400 transition"
                                        >
                                            +
                                        </button>
                                    </div>
                                </div>

                                {/* Remove Button */}
                                <button
                                    onClick={() => removeFromCart(item.id, item.variant)}
                                    className="mt-4 md:mt-0 md:ml-4 text-rose-300 transition relative group"
                                >
                                    <FiTrash2 size={24} className="group-hover:text-rose-400 transition-colors duration-300" />
                                    {/* Underline on hover - desktop only */}
                                    <span className="hidden md:block absolute w-0 h-0.5 bg-rose-300 left-0 bottom-0 group-hover:w-full transition-all duration-300"></span>
                                </button>
                            </div>
                        ))}

                        {/* Cart Summary */}
                        <div className="glass border border-rose-300 p-6 rounded-lg shadow-lg flex flex-col md:flex-row items-center justify-between">
                            <h3 className="text-2xl font-bold">
                                Total: <span className="text-rose-400">${totalPrice.toFixed(2)}</span>
                            </h3>
                            <button
                                className="mt-4 md:mt-0 px-8 py-3 bg-rose-300 text-black text-lg font-semibold rounded-lg hover:bg-rose-400 transition shadow-md"
                                onClick={handleProceedToCheckout}
                            >
                                Checkout
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default CartPage;
